// extracted by mini-css-extract-plugin
module.exports = {"element":"_02712f2b3b--element--hhgQA","underline":"_02712f2b3b--underline--paR4s"};